import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MicrosoftService } from './microsoft.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  	providedIn: 'root'
})
export class MicrosoftPowerBIService extends MicrosoftService {

	get baseUrl () {return 'https://api.powerbi.com/v1.0/myorg/'};

    get baseScopes () { return [
        "https://analysis.windows.net/powerbi/api/App.Read.All",
        "https://analysis.windows.net/powerbi/api/Content.Create",
        "https://analysis.windows.net/powerbi/api/Dataset.Read.All",
        "https://analysis.windows.net/powerbi/api/Report.Read.All",
        "https://analysis.windows.net/powerbi/api/UserState.ReadWrite.All",
        "https://analysis.windows.net/powerbi/api/Workspace.Read.All"
    ]};

	constructor(http: HttpClient, protected apiService: ApiService, protected msalService: MsalService) { super(http, apiService, msalService); }
}